import useNavigateCart from '~/hooks/useNavigateCart';
import { cartStore } from '~/stores';

const CART_BADGE_MAX = 9;

export const useCartButton = () => {
  const handleNavigateCart = useNavigateCart({ source: 'CartButton' });
  const cartCount = cartStore.totalCartCount;
  const cartBadgeLabel =
    cartCount > 0
      ? cartCount > CART_BADGE_MAX
        ? `${CART_BADGE_MAX}+`
        : cartCount
      : null;

  return { cartCount, cartBadgeLabel, handleNavigateCart };
};
